import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { saveAs } from 'file-saver';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { showLoader, hideLoader } from '../../../../store/common/slice';
import { useAccessToken } from '../../../../common/hooks/useAccessToken';
import BllinkUtils from '../../../../common/utils/utils';
import { constants } from '../../../../common/constants/constants';
import Download from '../../../../images/newDesign/download.svg';
import DownloadDisabled from '../../../../images/newDesign/downloadDisabled.svg';
import { ActionsCardWrapper } from '../BankAdjustmentsNew.styled';
import {Currency} from "../../../../common/currency";

const ActionsCard = ({ date, amount, currency, paymentType, paymentObject, paymentMethod, documentNumber, paymentID, hasReceipt, method, noFile=false }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const client = useAccessToken();

    const ltr = useSelector(state => state.common.ltrEnabled);

    const keys = constants.APIContract.paymentMethodsKeys;

    const paymentDocumentTitle = 
        method?.toString() === keys.cheque ? t('expenses.bank_adjustments.cheque_number') : 
        method?.toString() === keys.wire ? t('expenses.bank_adjustments.wire_number') : 
        method?.toString() === keys.bankCharge ? t('expenses.bank_adjustments.bank_number') :
        method?.toString() === keys.cash ? t('expenses.bank_adjustments.cash_number') : 
        t('expenses.bank_adjustments.document_number');

    const parsedDate = BllinkUtils.BllinkTime.parseDate(date);
    const parsedAmount = BllinkUtils.Strings.numberWithCommas(amount);
    const parsedPaymentObject =
        paymentType === t('expenses.expense') && paymentObject ? t(`expenses.expenseTypes.${paymentObject}`) : 
        paymentType === t('expenses.income') && paymentObject ? t('expenses.bank_adjustments.apt_num', {"apt": paymentObject}) : ''

    const downloadDocument = async () => {
        dispatch(showLoader());
        const response = await client.get(`/managers/receipt/${paymentID}`);
        if (response.urls.length) response.urls.forEach(file => saveAs(file.url, file.fileName));
        dispatch(hideLoader());
    };

    return (
        <ActionsCardWrapper noFile={noFile} ltr={ltr}>
            <div className='actions-header'>
                <div>
                    {t('expenses.date')}:
                    <span>{parsedDate}</span>
                </div>
                <div>
                    {t('offline_payments.amount')}:
                    <span>{parsedAmount} <Currency>{currency}</Currency></span>
                </div>
            </div>
            <div className='info-wrapper'>
                    <div className='info-container'>
                        <span>{t('expenses.type')}</span>
                        {paymentMethod !== keys.cash && (                      
                            <span className='info-span'>{paymentType}</span>
                        )}
                    </div>

                    <div className='info-container'>
                        <span>{paymentType === t('expenses.expense') ? t('expenses.bank_adjustments.to') : t('expenses.bank_adjustments.from')}</span>
                        <span className='info-span'>{parsedPaymentObject}</span>
                    </div>

                    <div className='info-container'>
                        <span>{t('expenses.payment_method')}</span>
                        <span className='info-span'>{paymentMethod}</span>
                    </div>

                    <div className='info-container'>
                        <span>{paymentDocumentTitle}</span>
                        {paymentMethod !== keys.cash && (
                            <>
                                <span className='info-span'>{documentNumber}</span>                       
                            </>
                        )}
                    </div>
                    
                    {
                        !noFile && (
                            <div className='info-container'>
                                <span>{t('expenses.bank_adjustments.file')}</span>
                                <span className='download-button'>{hasReceipt ? 
                                    <img src={Download} alt="download" className='download-file' onClick={downloadDocument} /> : 
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={props => (
                                            <Tooltip {...props}>
                                                {t('expenses.bank_adjustments.no_receipt')} 
                                            </Tooltip>
                                        )}
                                    >
                                        <img src={DownloadDisabled} alt="download" />
                                    </OverlayTrigger>}
                                </span>                   
                            </div>
                        )
                    }
            </div>
        </ActionsCardWrapper>
    );
};

export default ActionsCard;
